export const currencyOptions = [
  { label: "NGN", value: "₦" },
  { label: "USD", value: "$" },
  { label: "EUR", value: "€" },
  { label: "GBP", value: "£" },
];
